/* eslint-disable import/prefer-default-export */
export const RADIO_BUTTON_SIZE = {
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const DEFAULT_QUESTIONS_PER_COLUMN = 4;

export const DEFAULT_MS_TIMEOUT_TO_ADVANCE = 200;

export const HINT_ICON_ID = 'data-icon';
